module.exports = __webpack_public_path__ + "img/symbol_5.f3a0ee68.png";